<template>
  <h1 class="thing">Page not found!</h1>
</template>

<script>
export default { name: 'PageNotFound' }
</script>
